import { PROFILE_PAGE_FORMATTED_CALLCENTER_TELEPHONE_NUMBER, PROFILE_PAGE_PREFIXED_CALLCENTER_TELEPHONE_NUMBER } from '@/costants';
import { trackPhoneNumberClick } from '@/utils/trackingGtm';

const PhoneNumberCTA = ({
  anchorClassName = '',
  className = 'only:',
  anchorText = 'oppure chiama il',
}: {
  anchorClassName?: string;
  className?: string;
  anchorText?: string;
}) => (
  <a
    href={`tel:${PROFILE_PAGE_PREFIXED_CALLCENTER_TELEPHONE_NUMBER}`}
    data-cy="phone-number-cta"
    className={`${className} text-center text-base font-normal text-primary md:text-sm`}
    onClick={() => trackPhoneNumberClick()}
  >
    {anchorText}{' '}
    <span className={`${anchorClassName} text-base font-semibold text-inherit underline md:text-sm`}>
      {PROFILE_PAGE_FORMATTED_CALLCENTER_TELEPHONE_NUMBER}
    </span>
  </a>
);

export default PhoneNumberCTA;
